export const TEMPERATURA_V1ResourcesEN: TEMPERATURA_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errorMissingInput: "Please fill in all fields",
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  input: {
    signatureTitle: "Signature",
    datum: {
      label: "Please enter date",
      placeholder: "Please enter date",
      name: "datum",
    },
    ocitanaTemperatura: {
      label: "Read temperature",
      name: "ocitanaTemperatura",
      placeholder: "Please enter read temperature",
    },
    dozvoljenaTempMin: {
      label: "Minimum allowed temperature",
      name: "dozvoljenaTempMin",
      placeholder: "Please enter minimum temperature",
    },
    dozvoljenaTempMax: {
      label: "Maximum allowed temperature",
      name: "dozvoljenaTempMax",
      placeholder: "Please enter maximum temperature",
    },
    dozvoljenoOdstupanje: {
      label: "Allowed deviation",
      name: "dozvoljenoOdstupanje",
      placeholder: "Please enter allowed deviation",
    },
    stanje: {
      label: "Is the condition outside allowed values?",
    },
    vrijemeKorekcije: {
      label: "Select correction time",
      name: "vrijemeKorekcije",
      placeholder: "Select correction time",
    },
    opisMjeereKorekcije: {
      label: "Description of correction measure",
      name: "opisMjeereKorekcije",
      placeholder: "Select description of correction measure",
    },
    ocitanaTemperaturaKorekcije: {
      label: "Read correction temperature",
      name: "ocitanaTemperaturaKorekcije",
      placeholder: "Please enter read correction temperature",
    },
    dozvoljenaTempMinKorekcije: {
      label: "Minimum allowed correction temperature",
      name: "dozvoljenaTempMinKorekcije",
      placeholder: "Please enter minimum correction temperature",
    },
    dozvoljenaTempMaxKorekcije: {
      label: "Maximum allowed correction temperature",
      name: "dozvoljenaTempMaxKorekcije",
      placeholder: "Please enter maximum correction temperature",
    },
    dozvoljenoOdstupanjeKorekcije: {
      label: "Allowed correction deviation",
      name: "dozvoljenoOdstupanjeKorekcije",
      placeholder: "Please enter allowed correction deviation",
    },
    imePrezimeKorekcije: {
      name: "imePrezimeKorekcije",
      placeholder: "Please enter first and last name for correction",
      label: "Please enter first and last name",
    },
    potpisIzvrsiocaKorekcije: { label: "Signature of correction executor" },
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
};

interface InputField {
  label: string;
  name?: string;
  placeholder?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ocitanaTemperatura: InputField;
  dozvoljenaTempMin: InputField;
  dozvoljenaTempMax: InputField;
  dozvoljenoOdstupanje: InputField;
  stanje: InputField;
  vrijemeKorekcije: InputField;
  opisMjeereKorekcije: InputField;
  ocitanaTemperaturaKorekcije: InputField;
  dozvoljenaTempMinKorekcije: InputField;
  dozvoljenaTempMaxKorekcije: InputField;
  dozvoljenoOdstupanjeKorekcije: InputField;
  imePrezimeKorekcije: InputField;
  potpisIzvrsiocaKorekcije: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface TEMPERATURA_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
